import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';



const TopBarSlider = ({ activePageId, children }) => {

    const headerSliderRef = useRef()
    const windowWidth = useSelector((state) => state.eventListenerSlice?.windowSize)?.width

    const [visible, setVisible] = useState({
        left: false,
        right: true
    })

    useEffect(() => {
        onSliderScroll()
    }, [activePageId, windowWidth])

    const onSliderScroll = (direction) => {

        if (!headerSliderRef?.current) return
        const visibleWidth = headerSliderRef.current.clientWidth
        const scrollLeft = headerSliderRef.current.scrollLeft
        const scrollWidth = headerSliderRef.current.scrollWidth
        if (!direction) {

            setVisible({
                left: scrollLeft !== 0,
                right: (scrollLeft + visibleWidth) < scrollWidth
            })

            return

        }

        if (direction === "right") {

            const newScrollPosition = scrollLeft + visibleWidth * 0.7

            headerSliderRef.current.scrollTo({
                left: newScrollPosition,
                behavior: 'smooth' // Smooth scrolling animation
            });

            return
        }

        const newScrollPosition = scrollLeft - visibleWidth * 0.7
        headerSliderRef.current.scrollTo({
            left: newScrollPosition,
            behavior: 'smooth' // Smooth scrolling animation
        });
        return


    }

    const handleWheel = (event) => {
        if (headerSliderRef.current) {
            headerSliderRef.current.scrollLeft += event.deltaY;
        }
    };

    useEffect(() => {
        const headerSlider = headerSliderRef.current;

        const handleScroll = () => {
            onSliderScroll();
        };

        if (headerSlider) {
            headerSlider.addEventListener('scroll', handleScroll);

            return () => {
                headerSlider.removeEventListener('scroll', handleScroll);
            };
        }
    }, []);
    return (
        <div className="  overflow-hidden relative flex items-center rounded-full p-3" >
            {visible.left &&
                <div className='absolute bg-white left-0 top-[50%] translate-y-[-50%] h-[60px] w-[35px]  flex items-center justify-center z-1' >
                    <div className='  flex items-center justify-center rounded-full h-[35px] w-[35px] overflow-y-hidden border-2 border-[rgba(168,168,168,0.3)] bg-white cursor-pointer' style={{ boxShadow: "7px 0px 7px 1px rgba(168,168,168,0.2)" }} onClick={() => { onSliderScroll("left") }}>
                        <svg className="m-auto duration-300 stroke-[#8A92A6] shrink-0 rotate-90" width="13" height="13" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg" ><path d="M11 1L6.88384 5.13385C6.39773 5.62205 5.60227 5.62205 5.11616 5.13385L1 1" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                    </div>
                </div>
            }
            {visible.right &&
                <div className='absolute bg-white right-0 top-[50%] translate-y-[-50%] h-[60px] w-[35px]  flex items-center justify-center  z-1' >
                    <div className='  flex items-center justify-center rounded-full h-[35px] w-[35px] overflow-y-hidden border-2 border-[rgba(168,168,168,0.3)] bg-white cursor-pointer' style={{ boxShadow: "-7px 0px 7px 1px rgba(168,168,168,0.2)" }} onClick={() => { onSliderScroll("right") }}>
                        <svg className="m-auto duration-300 stroke-[#8A92A6] shrink-0 rotate-[270deg]" width="13" height="13" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg" ><path d="M11 1L6.88384 5.13385C6.39773 5.62205 5.60227 5.62205 5.11616 5.13385L1 1" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                    </div>
                </div>
            }
            <div className='w-full flex flex-row  gap-2 justify-start content-center overflow-scroll' ref={headerSliderRef} onWheel={(e) => { handleWheel(e) }} >
                {children}
            </div>
        </div>
    );
};

export default TopBarSlider;
